import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/shared/services/order-service';
import { SendOrderService } from 'src/app/shared/services/send-order';
import { take, catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { ToastrService } from 'src/app/shared/services/toastr.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  public selectedStepIndex = 0;

  constructor(private router: Router, private orderService: OrderService, private sendOrderService: SendOrderService, private spinnerService: SpinnerService, private toastrService: ToastrService) { }

  ngOnInit(): void {

  }

  public onStepClick(stepIndex: number): void {
    this.selectedStepIndex = stepIndex;
  }

  public returnMenu() {
    this.router.navigate(["/all-products"]);
  }

  public async confirmClick(event) {
    this.selectedStepIndex = this.selectedStepIndex + event;
  }

}
